import {create} from "zustand"

interface HomepageTabState {
  currentTab: string
  setCurrentTab: (tab: string) => void
  previousTab: string
  setPreviousTab: (tab: string) => void
}

const useHomepageTabStore = create<HomepageTabState>((set) => ({
  currentTab: "Overview",
  setCurrentTab: (tab: string) => set({currentTab: tab}),
  previousTab: "",
  setPreviousTab: (tab: string) => set({previousTab: tab}),
}))

export default useHomepageTabStore
